import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IconName } from "../../helpers/icon-exports";
import { SvgIconComponent } from "../svg-icon/svg-icon.component";

@Component({
    selector: "gpd-pill",
    imports: [CommonModule, SvgIconComponent],
    templateUrl: "./gpd-pill.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./gpd-pill.component.css"]
})
export class GpdPillComponent {
  @Input() text: string = '';
  @Input() backgroundColor: string = 'var(--color-grey-100)';
  @Input() color: string = 'var(--color-grey-900)';
  @Input() hashed: boolean = false;
  @Input() hasBorder: boolean = true;
  @Input() icon: IconName | null = null;
  @Input() clickable: boolean = false;
  @Input() maxWidth: string = 'unset';
  /** Shows a trailing "x" button for removing this pill (e.g. deselecting a tag). */
  @Input() removable: boolean = false;

  @Output() onClick = new EventEmitter<any>();
  @Output() onRemove = new EventEmitter<any>();

  constructor() {}
}
